import { createFileRoute, redirect } from '@tanstack/react-router'
import { LandingPagesListPage } from '@/pages/LandingPages/LandingPagesListPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/landing-pages')({
  component: LandingPagesListPage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/landing-pages')) {
      throw redirect({ to: '/' })
    }
  },
})
